import http from '@/http'

const PATH = '/search'

export default {
    /**
     * @param {{term: string}} params
     * @returns {Promise<void>}
     */
    async globalSearch (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
